export const MAIL_ADDRESSES = {
  SUPPORT: 'support@up-sider.com',
}
